import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-y border-slate-800 bg-slate-900/50 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-73" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-74" data-mp="9wfq8g9f4oji">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-slate-700 bg-slate-950 p-8 shadow-2xl shadow-black/40 sm:p-12" data-id="element-75" data-mp="euh84xv3yhte">
          <span className="inline-flex rounded-full border border-amber-400/50 bg-slate-900 p-4 text-amber-400" data-id="element-76" data-mp="sn6xnc9ui4v9">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-77" data-mp="12ja7z5eup9ta" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-balance text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl" data-id="element-78" data-mp="17i4ou1t9coar">
            Garanzia di soddisfazione <span className="text-amber-400" data-id="element-79" data-mp="25ti40dzy6exd">di 7 giorni</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-300" data-id="element-80" data-mp="20rspuphfhl52">
            Se entro 7 giorni il materiale non fa per te,{' '}
            <span className="font-extrabold text-amber-400" data-id="element-81" data-mp="1vu0xxvgs9z0v">ti rimborsiamo. Senza domande.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}